<template>
  <v-container class="pa-0">
    <MobileTopPart />
    <v-row>
      <v-col>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              style="background: white; padding-bottom: 30px; width: 100%"
            >
              <div
                class="right-col"
                id="content-area"
                style="margin: 0 10px"
              >

               <PaymentForm />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
<!--    <v-row>-->
<!--      <PageFooter />-->
<!--    </v-row>-->
  </v-container>
</template>

<script>
import PageFooter from '@/components/App/_PageFooter'
import MobileTopPart from '@/components/Views/Layout/MobileTopPart'
import SearchForm from '@/components/Forms/SearchForm'
import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import sharedComputed from '@/methods/sharedComputed'
import articleComputed from '@/methods/articleComputed'
import sharedMethods from '@/methods/sharedMethods'
import BookingForm from '@/components/Forms/BookingForm'
import ObjectImages from '@/components/ObjectImages/ObjectImages'
import PaymentForm from '@/components/PaymentForm.vue'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'PaymentFormnMobile',

  props: {
    id: {
      type: String,
      default: null,
    },
  },

  components: {
    PaymentForm,
    MobileTopPart,
  },

  created() {
    // When user just came to the side
    // When opening from the menu, is already fine
    if (!this.userJustEntered) {
      return
    }
    setTimeout(() => {
      this.scrollToBeginningOfArticle()
    }, 100)
    setTimeout(() => {
      this.scrollToBeginningOfArticle()
    }, 1000)
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...articleComputed,
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
